// @ components
import { LoginRobo } from './LoginRobo';
// @ vendors
import { connect } from 'react-redux';
// @ actions
import { resetErrors, login } from 'actions/loginRoboActions';
import { resetOTP, verifyLoginOtpRobo } from 'actions/RAOtpActions';
import { showPreLoader, hidePreLoader } from 'actions/preLoaderActions';

const mapStateToProps = state => {
    return {
        userProfile: state.userProfile,
        loginRobo: state.loginRobo,
        immSteps: state.steps,
        immSuitabilityTest: state.raSuitabilityTest,
        immCheckStatus: state.raCheckStatus,
    };
};

const mapDispatchToProps = {
    resetErrors,
    login,
    resetOTP,
    verifyLoginOtpRobo,
    showPreLoader,
    hidePreLoader,
};

export const LoginRoboContainer = connect(mapStateToProps, mapDispatchToProps)(LoginRobo);
